import { ApiResult, HttpClient } from "../http.js";
import { PagedWalkthroughTemplates, WalkthroughTemplateDto } from "../types/walkthrough-templates.js";

export interface ListWalkthroughTemplatesQuery {
  page?: number;
  pageSize?: number;
  search?: string;
}

export interface CreateWalkthroughTemplatePayload {
  name: string;
  description?: string | null;
  categoriesJson?: string | null;
  id?: string;
}

export interface UpdateWalkthroughTemplatePayload {
  name: string;
  description?: string | null;
  categoriesJson?: string | null;
}

export class WalkthroughTemplatesApi {
  constructor(private readonly http: HttpClient) {}

  list(query: ListWalkthroughTemplatesQuery = {}): Promise<ApiResult<PagedWalkthroughTemplates>> {
    return this.http.get<PagedWalkthroughTemplates>("/api/walkthrough-templates", { query: { ...query } });
  }

  get(id: string): Promise<ApiResult<WalkthroughTemplateDto>> {
    return this.http.get<WalkthroughTemplateDto>(`/api/walkthrough-templates/${encodeURIComponent(id)}`);
  }

  create(payload: CreateWalkthroughTemplatePayload): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/walkthrough-templates", { body: payload });
  }

  update(id: string, payload: UpdateWalkthroughTemplatePayload): Promise<ApiResult<WalkthroughTemplateDto>> {
    return this.http.put<WalkthroughTemplateDto>(`/api/walkthrough-templates/${encodeURIComponent(id)}`, { body: payload });
  }

  archive(id: string): Promise<ApiResult<string>> {
    return this.http.post<string>(`/api/walkthrough-templates/${encodeURIComponent(id)}/archive`, {});
  }
}
